import { io } from 'socket.io-client';

const WS_BASE = process.env.REACT_APP_WS_BASE || process.env.REACT_APP_API_BASE || 'http://localhost:4000';

let socket = null;
let tokensListenerAttached = false;
let socketUsers = 0;

function getAccessToken() {
  try {
    return localStorage.getItem('access') || null;
  } catch {
    return null;
  }
}

export function getSocket() {
  return socket;
}

export function connectSocket() {
  socketUsers += 1;
  if (socket) {
    if (!socket.connected) {
      try { socket.connect(); } catch {}
    }
    return socket;
  }

  socket = io(WS_BASE, {
    transports: ['websocket'],
    auth: { token: getAccessToken() },
    autoConnect: true,
  });

  if (!tokensListenerAttached && typeof window !== 'undefined') {
    tokensListenerAttached = true;
    window.addEventListener('tokens:updated', () => {
      try {
        if (!socket) return;
        socket.auth = { ...(socket.auth || {}), token: getAccessToken() };
        if (socket.connected) {
          socket.disconnect();
        }
        socket.connect();
      } catch {
        // ignore
      }
    });
  }

  return socket;
}

export function disconnectSocket() {
  if (socketUsers > 0) socketUsers -= 1;
  if (!socket || socketUsers > 0) return;
  try {
    socket.disconnect();
  } catch {
    // ignore
  } finally {
    socket = null;
  }
}
